import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function currencyFormat(
  value: number,
  {
    currency,
    style,
  }: {
    currency?: Intl.NumberFormatOptions["currency"];
    style?: Intl.NumberFormatOptions["style"];
  } = {
    currency: "DKK",
    style: "currency",
  },
) {
  const lowerCaseCurrency = (currency || "DKK").toLowerCase();
  const locale = lowerCaseCurrency === "usd" ? "en-US" : "da-DK";

  return new Intl.NumberFormat(locale, {
    style: style || "currency",
    minimumIntegerDigits: 2,
    currency: currency || "DKK",
    currencyDisplay: "narrowSymbol",
    maximumFractionDigits: value % 1 !== 0 ? 2 : 0,
    minimumFractionDigits: value % 1 !== 0 ? 2 : 0,
  }).format(value);
}
